const NewsletterForm = (container) => {
    console.log(container);

    const hideForm = localStorage.getItem('newsletterForm');
    const showClass = 'newsletter-banner--active';
    const closeButton = document.querySelector('[data-newsletter-close]');

    if (!hideForm) {
        container.classList.add(showClass);
    }

    if (typeof closeButton != 'undefined' && closeButton) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            localStorage.setItem('newsletterForm', true);
            container.classList.remove(showClass);
        });
    }
}

export default NewsletterForm;


// WEBPACK FOOTER //
// ./src/js/app/components/NewsletterForm.js